export const getColumnBoxCtrStyles = (backgroundColor: string) => ({
	padding: '1.25rem 0',
	backgroundColor: `${backgroundColor}`,
});

export const columnItemBoxCtrStyles = (disableItemYPaddingOn?: boolean) => ({
	width: '100%',
	paddingY: disableItemYPaddingOn ? '' : '3.75rem',
});
